import { render } from "./ValuelistForm.vue?vue&type=template&id=d6ad36d0&scoped=true"
import script from "./ValuelistForm.vue?vue&type=script&lang=js"
export * from "./ValuelistForm.vue?vue&type=script&lang=js"

import "./ValuelistForm.vue?vue&type=style&index=0&id=d6ad36d0&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6ad36d0"]])

export default __exports__